/**
 * Action sub-type, set only when a node's type is Action.
 * Mirrors Osstre.Domain WorkflowNodeActionType.
 */
export enum WorkflowNodeActionType {
  /** Sends an email message */
  SendEmail = 'sendEmail',
  /** Calls a specified API endpoint */
  Webhook = 'webhook'
}
